import { render, staticRenderFns } from "./DesktopValidate.vue?vue&type=template&id=e3acc6d8&scoped=true&"
import script from "./DesktopValidate.vue?vue&type=script&lang=js&"
export * from "./DesktopValidate.vue?vue&type=script&lang=js&"
import style0 from "./DesktopValidate.vue?vue&type=style&index=0&id=e3acc6d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3acc6d8",
  null
  
)

export default component.exports